import { useState, useEffect } from "react";
import {
  FaHome,
  FaBox,
  // FaPlus,
  FaBars,
  FaBlog,
  FaUsers,
  FaDatabase,
  // FaSignInAlt,
  FaSignOutAlt,
  FaTimes
} from "react-icons/fa";
import "../sidebar.css";

function Sidebar({ collapsed, setCollapsed, onAddProductClick, onPageChange, currentPage, onLogout }) {
  const [activeItem, setActiveItem] = useState("dashboard");
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  useEffect(() => {
    if (currentPage) {
      setActiveItem(currentPage);
    }
  }, [currentPage]);

  useEffect(() => {
    const savedActiveItem = localStorage.getItem("activeSidebarItem");
    if (savedActiveItem && !currentPage) {
      setActiveItem(savedActiveItem);
      if (onPageChange) {
        onPageChange(savedActiveItem);
      }
    }
  }, []);

  // Close mobile sidebar when window resizes to desktop
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768 && isMobileOpen) {
        setIsMobileOpen(false);
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [isMobileOpen]);

  const handleItemClick = (itemName) => {
    // Handle logout separately
    if (itemName === "logout") {
      if (onLogout) {
        onLogout();
      }
      return;
    }
    
    setActiveItem(itemName);
    localStorage.setItem("activeSidebarItem", itemName);
    
    if (itemName === "addproduct" && onAddProductClick) {
      onAddProductClick();
    } else if (onPageChange) {
      onPageChange(itemName);
    }
    
    // Close mobile sidebar after click
    if (window.innerWidth <= 768) {
      setIsMobileOpen(false);
    }
  };

  const toggleMobileSidebar = () => {
    setIsMobileOpen(!isMobileOpen);
  };

  const menuItems = [
    { name: "dashboard", icon: <FaHome />, label: "Dashboard" },
    { name: "products", icon: <FaBox />, label: "Products" },
    // { name: "addproduct", icon: <FaPlus />, label: "Add Product" },
    { name: "blogs", icon: <FaBlog />, label: "Blogs" },
    { name: "data", icon: <FaDatabase />, label: "Data" },
    { name: "users", icon: <FaUsers />, label: "Users" },
    // { name: "login", icon: <FaSignInAlt />, label: "Login" },
    { name: "logout", icon: <FaSignOutAlt />, label: "Logout", isLogout: true }
  ];

  return (
    <>
      {/* Mobile Menu Button */}
      <button className="mobile-menu-btn" onClick={toggleMobileSidebar}>
        {isMobileOpen ? <FaTimes /> : <FaBars />}
      </button>
      
      {/* Sidebar Overlay for Mobile */}
      <div 
        className={`sidebar-overlay ${isMobileOpen ? 'active' : ''}`} 
        onClick={toggleMobileSidebar}
      />
      
      <div className={`sidebar ${collapsed ? "collapsed" : ""} ${isMobileOpen ? "mobile-open" : ""}`}>
        <div className="toggle-btn" onClick={() => setCollapsed(!collapsed)}>
          <FaBars />
          {!collapsed && <span></span>}
        </div>

        <ul>
          {menuItems.map((item) => (
            <li 
              key={item.name}
              className={`menu-item ${activeItem === item.name ? "active" : ""} ${item.isLogout ? "logout" : ""}`}
              onClick={() => handleItemClick(item.name)}
            >
              {item.icon}
              {!collapsed && <span>{item.label}</span>}
              {collapsed && <span className="tooltip">{item.label}</span>}
            </li>
          ))}
        </ul>
      </div>
    </>
  );
}

export default Sidebar;